import { Grid } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import React, { useState } from 'react'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'

interface IFirearm {
    open: boolean
    onClose: (action: string) => void
    item?: any
    itemType?: string
}

interface IAddMoreFormProps {
    data: any
}

const AddMoreForm = (props: IAddMoreFormProps) => {
    const { data } = props
    const [date, setDate] = useState<any>(null)
    const [readOnly, setReadOnly] = useState(true)

    const handleDateChange = (e: any) => {
        setDate(e)
    }

    return (
        <div>
            <p className="page-title">Seller Details</p>
            <Grid container spacing={2} className="mt-2">
                <Grid item sm={6} xs={12} className="pt-2">
                    <RedditTextField
                        label="FFL #"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.fflId}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <RedditTextField
                        label="Business Name"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.businessName}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <RedditTextField
                        label="Date of Purchase"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.issuedAt}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <RedditTextField
                        label="Address"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.address}
                    />
                </Grid>

                <Grid item sm={6} xs={12} className="pt-2">
                    {/* <BaseSelect label="City" fullWidth /> */}
                    <RedditTextField
                        label="City"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.cityName}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    {/* <BaseSelect label="State" fullWidth /> */}
                    <RedditTextField
                        label="State"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.stateName}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <RedditTextField
                        label="Zip Code"
                        className="reddit-input w-100"
                        variant="filled"
                        inputProps={{ readOnly }}
                        value={data?.zipCode}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

function FirearmModal(props: IFirearm) {
    // core section
    const { item, open, onClose, itemType } = props

    const [showAddBtn, setShowAddBtn] = useState(false)
    const [readOnly, setReadOnly] = useState(true)

    // states section

    // functions section
    const itemTitle =
        // eslint-disable-next-line no-nested-ternary
        itemType === 'FIREARM'
            ? 'Firearm'
            : itemType === 'ACCESSORY'
            ? 'Accessories'
            : 'Part'
    return (
        <CustomModal
            onClose={(action) => onClose && onClose(action)}
            open={open && open}
            modalTitle={itemTitle}
        >
            <div className="modal-body p-0 pb-3">
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <div
                            className="page-img-box mb-3"
                            style={{ height: '233px' }}
                        >
                            <img
                                src={
                                    item?.imageUrl ||
                                    require('@Images/icons/camera-icon.svg')
                                        .default
                                }
                                alt=""
                            />
                        </div>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        {itemType !== 'PART' && (
                            <>
                                <RedditTextField
                                    label="Make"
                                    className="reddit-input mb-2 w-100"
                                    variant="filled"
                                    value={item?.makeName}
                                    inputProps={{ readOnly }}
                                />
                                <RedditTextField
                                    label="Model"
                                    className="reddit-input mb-2 w-100"
                                    variant="filled"
                                    value={item?.modelName}
                                    inputProps={{ readOnly }}
                                />
                                <RedditTextField
                                    label="Caliber"
                                    className="reddit-input mb-2 w-100"
                                    variant="filled"
                                    value={item?.caliber}
                                    inputProps={{ readOnly }}
                                />
                            </>
                        )}
                        {itemType === 'PART' && (
                            <RedditTextField
                                label="Component"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                value={item?.component}
                                inputProps={{ readOnly }}
                            />
                        )}
                        <RedditTextField
                            label="Serial #"
                            className="reddit-input mb-2 w-100"
                            variant="filled"
                            value={item?.serialCode || ''}
                            inputProps={{ readOnly }}
                        />
                        {itemType !== 'PART' && (
                            <RedditTextField
                                label="Firearms Type"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                value={item?.firearmTypeName}
                                inputProps={{ readOnly }}
                            />
                        )}
                        <RedditTextField
                            label="Fee"
                            className="reddit-input mb-2 w-100"
                            variant="filled"
                            value={item?.fee}
                            inputProps={{ readOnly }}
                        />
                    </Grid>
                </Grid>
                {/* {!showAddBtn && (
                    <div className="text-right mt-2">
                        <AddCircleOutlineIcon
                            className="main-text cursor-pointer"
                            onClick={() => setShowAddBtn(true)}
                        />
                    </div>
                )} */}

                {/* {showAddBtn && <AddMoreForm />} */}
                <AddMoreForm data={item?.transactionDetail} />
            </div>
            <div className="modal-footer">
                <span className="modal-action" onClick={(e: any) => onClose(e)}>
                    Close
                </span>
                <div className="divider" />
            </div>
        </CustomModal>
    )
}

export default FirearmModal
